// User accounts for Penama Teacher Portal
export const users = [
  {
    id: 'admin-001',
    name: 'Administrator',
    email: 'admin@spc.edu.vu',
    password: '4Tari@spc2025',
    role: 'admin',
    classes: 'all', // Admin can access all resources
    permissions: ['view_all', 'manage_users', 'manage_curriculum', 'view_analytics'],
    school_type: 'senior_secondary'
  },
  {
    id: 'principal-001',
    name: 'Principal',
    email: 'principal@spc.edu.vu',
    password: '4Tari@spc2022',
    role: 'principal',
    classes: 'none', // Principal does not access class resources
    permissions: ['view_analytics_only'], // Only analytics/monitoring
    dashboardOnly: true, // Special flag for principal
    school_type: 'senior_secondary'
  },
  {
    id: 'teacher-001',
    name: 'Sarah Johnson',
    email: 'sarah@penama.edu.vu',
    password: 'password123',
    role: 'teacher',
    department: 'Science Department',
    classes: 'all', // Can access all classes
    permissions: ['view_curriculum', 'manage_assessments', 'view_students']
  },
  {
    id: 'teacher-002',
    name: 'Roy Tari',
    email: 'roytari@spc.edu.vu',
    password: '4Tari@spc2022',
    role: 'teacher',
    department: 'Technology Department',
    classes: ['Year 13 Computer Studies', 'Year 12 Computer Studies', 'Year 11 Computer Studies'], // Only Senior Computer Studies classes
    permissions: ['view_curriculum', 'manage_assessments', 'view_students'],
    restrictedTo: 'computer-studies', // Special flag for filtering
    school_type: 'senior_secondary'
  },
  {
    id: 'teacher-003',
    name: 'Ms. Jovlyn',
    email: 'jovlyn@spc.edu.vu',
    password: '4Tari@spc2022',
    role: 'teacher',
    department: 'Mathematics & Accounting Department',
    classes: ['Year 7 Mathematics', 'Year 11 Accounting', 'Year 12 Accounting', 'Year 13 Accounting'], // Junior Math and Senior Accounting
    permissions: ['view_curriculum', 'manage_assessments', 'view_students'],
    school_type: 'senior_secondary'
  },
  {
    id: 'teacher-004',
    name: 'Mr. Lausen',
    email: 'lausen@spc.edu.vu',
    password: '4Tari@spc2022',
    role: 'teacher',
    department: 'Languages Department',
    classes: ['Year 11 French', 'Year 12 French', 'Year 13 French'], // Senior French classes only
    permissions: ['view_curriculum', 'manage_assessments', 'view_students'],
    restrictedTo: 'french', // Special flag for filtering French classes
    school_type: 'senior_secondary'
  },
  {
    id: 'teacher-005',
    name: 'Ms. Janella Boe',
    email: 'janella.boe@spc.edu.vu',
    password: '4Tari@spc2022',
    role: 'teacher',
    department: 'Social Sciences Department',
    classes: ['Year 11 Development Studies', 'Year 12 Development Studies', 'Year 13 Development Studies'], // Development Studies classes only
    permissions: ['view_curriculum', 'manage_assessments', 'view_students'],
    restrictedTo: 'development-studies', // Special flag for filtering Development Studies classes
    school_type: 'senior_secondary'
  },
  {
    id: 'teacher-006',
    name: 'Mrs. Watson Moli',
    email: 'watsonmoli@spc.edu.vu',
    password: '4Tari@spc2022',
    role: 'teacher',
    department: 'Mathematics Department',
    classes: ['Year 11 Mathematics', 'Year 12 Mathematics', 'Year 13 Mathematics'], // Senior Mathematics only
    permissions: ['view_curriculum', 'manage_assessments', 'view_students'],
    restrictedTo: 'senior-mathematics', // Special flag for Senior Mathematics only
    school_type: 'senior_secondary'
  }
];

// Helper function to authenticate user
export const authenticateUser = (email, password) => {
  const user = users.find(u => u.email.toLowerCase() === email.toLowerCase() && u.password === password);
  if (user) {
    // Return user without password
    const { password: _, ...userWithoutPassword } = user;
    return userWithoutPassword;
  }
  return null;
};

// Helper function to check if user can access a class
export const canAccessClass = (user, className) => {
  if (!user) return false;
  if (user.role === 'admin' || user.classes === 'all') return true;
  if (Array.isArray(user.classes)) {
    return user.classes.includes(className);
  }
  return false;
};

// Helper function to filter classes list based on user permissions
export const filterClassesByUser = (allClasses, user) => {
  if (!user) return [];
  if (user.role === 'admin' || user.role === 'principal' || user.classes === 'all') return allClasses;
  if (Array.isArray(user.classes)) {
    // If user has restrictedTo flag (like 'computer-studies' or 'french'), filter by subject
    if (user.restrictedTo === 'computer-studies') {
      return allClasses.filter(cls => {
        const className = typeof cls === 'string' ? cls : (cls.title || cls.name || cls.className || '');
        return className.toLowerCase().includes('computer studies');
      });
    }
    if (user.restrictedTo === 'french') {
      return allClasses.filter(cls => {
        const className = typeof cls === 'string' ? cls : (cls.title || cls.name || cls.className || '');
        return className.toLowerCase().includes('french');
      });
    }
    if (user.restrictedTo === 'development-studies') {
      return allClasses.filter(cls => {
        const className = typeof cls === 'string' ? cls : (cls.title || cls.name || cls.className || '');
        return className.toLowerCase().includes('development studies');
      });
    }
    return allClasses.filter(cls => {
      const className = typeof cls === 'string' ? cls : (cls.title || cls.name || cls.className || '');
      return user.classes.includes(className);
    });
  }
  return [];
};

// Helper function to filter assessments by user
export const filterAssessmentsByUser = (allAssessments, user) => {
  if (!user) return {};
  if (user.role === 'admin' || user.role === 'principal' || user.classes === 'all') return allAssessments;
  
  // Filter assessments to only show those for accessible classes
  const filtered = {};
  Object.keys(allAssessments).forEach(className => {
    if (canAccessClass(user, className)) {
      filtered[className] = allAssessments[className];
    }
  });
  return filtered;
};

// Get current logged in user
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('currentUser');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};
